import React from 'react';
import Dropzone from 'react-dropzone';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';
import { withLocalize } from 'react-localize-redux';

const Dz = (props) => {
  const {
    onDrop, accept, translate, maxSize
  } = props;

  return (
    <Dropzone
      maxSize={maxSize}
      accept={accept}
      multiple={false}
      onDrop={onDrop}
      className='reactCrop_dropZone'
    >
      <span className='reactCrop_dropZone_txt'>
        {translate('uploader.text.dragAndDrop')}
      </span>
      <Button primary className='reactCrop_selectBtn'>
        {translate('uploader.text.selectFile')}
      </Button>
    </Dropzone>
  );
};

Dz.propTypes = {
  accept: PropTypes.string,
  onDrop: PropTypes.func
};

Dz.defaultProps = {
  accept: undefined,
  onDrop: () => {}
};

export default withLocalize(Dz);



// WEBPACK FOOTER //
// ./src/components/uploader/Dropzone.js